const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export interface LoginFormValidation {
  valid: boolean;
  missingFields: boolean;
  invalidEmail: boolean;
}

/**
 * Client-side validation for email/password login (before network call).
 * @param {string} username
 * @param {string} password
 * @returns {LoginFormValidation}
 */
export function validateLoginForm(username: string, password: string): LoginFormValidation {
  const trimmedUsername = username.trim();
  const missingFields = trimmedUsername === '' || password === '';
  const invalidEmail = trimmedUsername !== '' && !EMAIL_REGEXP.test(trimmedUsername);

  return {
    valid: !missingFields && !invalidEmail,
    missingFields,
    invalidEmail,
  };
}
